import { componentWithFG } from '@confluence/feature-gate-component';
import { LoadableAfterPaint } from '@confluence/loadable';

import { EditorControlsFeedbackCollector as EditorControlsFeedbackCollectorSync } from './EditorControlsFeedbackCollector';

export const EditorControlsFeedbackCollectorAsync = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-EditorControlsFeedbackCollector" */ './EditorControlsFeedbackCollector'
			)
		).EditorControlsFeedbackCollector,
});

export const EditorControlsFeedbackCollector = componentWithFG(
	'platform_editor_controls_banner_preload',
	EditorControlsFeedbackCollectorAsync,
	EditorControlsFeedbackCollectorSync,
);
